import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { ISendFiletoJob } from "../contracts";

export function useSendFileProductGrouptoJobRule() {
  const { request } = usePbm2Url();

  return useMutation(
    async (variables: { input: { programID: string; fileName: string } }) => {
      const { Rules_sendFileProductGrouptoJobRule } = await request(
        gql`
          mutation Rules_sendFileProductGrouptoJobRule(
            $input: Rules_LoadProductGroupRulesInput!
          ) {
            Rules_sendFileProductGrouptoJobRule(input: $input) {
              processed
              message
            }
          }
        `,
        variables
      );

      return Rules_sendFileProductGrouptoJobRule as ISendFiletoJob;
    }
  );
}
